module.exports = "<pre id=\"json\"></pre>\n\n<button (click)=\"goBack()\" class=\"btn btn-primary btn-margin my-2 my-sm-0 btn-danger btn2\" >Back</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/patients/detail/patient-auth-detail.component.html
// module id = 1118
// module chunks = 1